module.exports = __webpack_public_path__ + "static/media/HEART2.f308d862.png";